import { useEffect, useCallback, useRef } from 'react';
export function useClickOnOutside(onClickOutside) {
    const elementRef = useRef(null);
    const handleClick = useCallback((event) => {
        if (!elementRef.current.contains(event.target)) {
            onClickOutside();
        }
    }, [onClickOutside, elementRef]);
    useEffect(() => {
        document.addEventListener('mousedown', handleClick);
        return () => {
            document.removeEventListener('mousedown', handleClick);
        };
    }, [handleClick]);
    return {
        elementRef
    };
}
//# sourceMappingURL=useClickOnOutside.js.map